/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { TeamsInRegion } from "@microsoft/shifts-models-data";
import { ListItem } from "@microsoft/shifts-models-view";

import { ICrossLocationTeamMapper } from "./ICrossLocationTeamMapper";

/**
 * The interface for cross-location team mapper.
 */
export class CrossLocationTeamMapper implements ICrossLocationTeamMapper {
    /**
     * Maps teams in region data model to list item view model.
     * @param teams The teams in region to map.
     * @returns The list items.
     */
    public toListItem(teams: TeamsInRegion): ListItem[] {
        return teams.map(({ id, name }) => ({
            label: name,
            value: id
        }));
    }
}
